var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65269 0.14689L0.143712 3.72476C-0.0479049 3.93306 -0.0479049 4.25164 0.143712 4.44769C0.335329 4.64374 0.658682 4.64374 0.850299 4.44769L4 1.22515L7.1497 4.44769C7.35329 4.64374 7.66467 4.64374 7.85629 4.44769C8.0479 4.25164 8.0479 3.93307 7.85629 3.72476L4.35928 0.14689C4.15569 -0.0491575 3.84431 -0.0491575 3.65269 0.14689Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.34ddf002627300ebd4e90554725ec665.svg";
export { ForwardRef as ReactComponent };